import type { LessonPracticeLink } from '../store/api/learningApi';

/**
 * Build the /practice URL for a lesson's authored practice link.
 *
 * - free → `/practice?mode=free` (record-and-review speaking practice)
 * - npc  → `/practice?mode=npc[&scenario=<scenarioKey>]` (PracticePage seeds its
 *   NPC scenario filter from `scenario`)
 *
 * Returns null when the lesson has no link (or an unknown mode), so the page
 * shows no "Practice this" button rather than a guessed destination.
 */
export function lessonPracticeHref(link: LessonPracticeLink | undefined | null): string | null {
  if (!link) return null;
  const params = new URLSearchParams();
  if (link.mode === 'free') {
    params.set('mode', 'free');
  } else if (link.mode === 'npc') {
    params.set('mode', 'npc');
    if (link.scenarioKey) params.set('scenario', link.scenarioKey);
  } else {
    return null;
  }
  return `/practice?${params.toString()}`;
}
